import { debounce } from "lodash-es"
import React, { useState } from "react"
import CustomAlert from "components/Atoms/CustomAlert"
import CustomButton from "components/Atoms/CustomButton"
import CustomMarker from "components/Organisms/map/CustomMarker"
import StickyPolygon from "components/Templates/StickyPolygon"

const SurveyAreaPolygon = ({
  coordinates,
  enableDrawing,
  onChange,
  onRemove,
  disableStickyPoints,
  colorCode,
  allVertices,
}) => {
  const [alertVisible, setAlert] = useState(false)
  const [overlayVisible, setOverlay] = useState(false)

  const bounds = new window.google.maps.LatLngBounds()
  coordinates && coordinates.forEach(co => bounds.extend(co))
  const center = bounds?.getCenter()?.toJSON()

  const onMouseOut = debounce(e => setOverlay(false), 750)

  return (
    <>
      <StickyPolygon
        boundaryPoints={allVertices}
        disableStickyPoints={disableStickyPoints}
        onMouseOver={e => setOverlay(true)}
        onMouseOut={onMouseOut}
        options={{
          editable: enableDrawing,
          strokeOpacity: 1,
          strokeWeight: 2,
          fillOpacity: 0.7,
          fillColor: colorCode,
          strokeColor: colorCode,
        }}
        onChange={coords => {
          enableDrawing && onChange(coords)
        }}
        editable
        path={coordinates}
      />
      {overlayVisible && enableDrawing && center?.lat && (
        <CustomMarker position={center}>
          <CustomButton
            icon="trash"
            onClick={e => {
              setAlert(true)
            }}
          />
        </CustomMarker>
      )}
      {enableDrawing && (
        <CustomAlert
          intent="danger"
          icon="warning-sign"
          light
          cancelButtonText="Cancel"
          onClose={confirm => {
            if (confirm) {
              onRemove()
            }
            setAlert(false)
          }}
          confirmButtonText="Delete"
          isOpen={alertVisible}
        >
          <p>Are you sure you want to delete this polygon ?</p>
        </CustomAlert>
      )}
    </>
  )
}

export default SurveyAreaPolygon
